<!--站点一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">平台公告</span>
      </div>
      <div class="right">
        <Button type="primary" @click="gotoEdit(0)">新增</Button>
        <Button v-if="!user.tp" type="primary" @click="msgPush" style="margin-left: 10px"
          >消息推送</Button
        >
        <Button @click="$router.back()" style="margin-left: 10px">返回</Button>
      </div>
    </div>

    <Table :columns="columns" :data="data" :loading="tableLoading" />
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      page: {
        p: 0,
        l: 10
      },
      data: [],
      total: 0,
      tableLoading: false,
      columns: [
        { title: '编号', key: 'id' },
        { title: '标题', key: 'title' },
        { title: '浏览', key: 'see' },
        {
          title: '操作',
          key: 'operator',
          render: (h, data) => {
            return h('div', {}, [
              h(
                'Button',
                {
                  props: {
                    size: 'small',
                    type: data.row.is_del ? 'success' : 'error'
                  },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `是否删除`,
                        content: `是否删除`,
                        loading: this.confirmLoading,
                        onOk: () => {
                          this.confirmLoading = true
                          this.del(data.row.id)
                        }
                      })
                    }
                  }
                },
                data.row.is_del ? '恢复' : '删除'
              ),
              h(
                'Button',
                {
                  props: { size: 'small', type: 'warning' },
                  on: {
                    click: () => {
                      this.gotoEdit(data.row.id)
                    }
                  }
                },
                '修改'
              )
            ])
          }
        }
      ],
      loading: false,
      confirmLoading: false
    }
  },
  methods: {
    search () {
      this.page.p = 0
      this.getData()
    },
    reset () {
      this.page.p = 0
      this.page.key = ''
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData () {
      this.tableLoading = true
      this.GetNoticeList(this.page).then((res) => {
        this.total = res.data.total
        this.data = res.data.list
        this.tableLoading = false
      })
    },
    del (id) {
      this.DeleteNotice({ id }).then((res) => {
        this.confirmLoading = false
        this.getData()
      })
    },
    gotoEdit (id = 0) {
      this.$router.push({ path: '/notice/edit', query: { id } })
    },
    // 消息推送
    msgPush () {
      this.$Modal.confirm({
        title: `温馨提示`,
        content: `是否确定推送消息?`,
        onOk: () => {
          this.MsgPush({ type: 1 }).then((res) => {
            console.log('消息推送成功')
            this.$Message.success('消息推送成功')
          })
        }
      })
    },
    ...mapActions(['GetNoticeList', 'DeleteNotice', 'MsgPush'])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  }),
  watch: {
    'page.is_del' (n, o) {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
